import apiService from './apiService';

const PREFIX = '/iti/fonctionnalites';
const ADMIN_PREFIX = '/iti/admin/fonctionnalites';

async function request(promise) {
  const res = await promise;
  if (!res.success) {
    throw new Error(res.message || 'Erreur API');
  }
  return res.data;
}

const itiFonctionnaliteService = {
  async getGroups() {
    const data = await request(apiService.get(PREFIX));
    return data.groups ?? [];
  },

  async getAdminTree() {
    const data = await request(apiService.get(ADMIN_PREFIX));
    return data.categories ?? [];
  },

  async createCategory(payload) {
    const data = await request(apiService.post(`${ADMIN_PREFIX}/categories`, payload));
    return data.categorie;
  },

  async updateCategory(id, payload) {
    const data = await request(apiService.patch(`${ADMIN_PREFIX}/categories/${id}`, payload));
    return data.categorie;
  },

  async deleteCategory(id) {
    return request(apiService.delete(`${ADMIN_PREFIX}/categories/${id}`));
  },

  async createOption(payload) {
    const data = await request(apiService.post(`${ADMIN_PREFIX}/options`, payload));
    return data.option;
  },

  async updateOption(id, payload) {
    const data = await request(apiService.patch(`${ADMIN_PREFIX}/options/${id}`, payload));
    return data.option;
  },

  async deleteOption(id) {
    return request(apiService.delete(`${ADMIN_PREFIX}/options/${id}`));
  },
};

export default itiFonctionnaliteService;
